import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tt_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imgUrl = (u) => {
  if (!u) return "";
  return u.startsWith("http") ? u : `${BACKEND_URL}${u}`;
};

export const uploadMedia = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { url, path, type }
};

export const uploadImage = async (file) => (await uploadMedia(file)).url;
